import { jsBridgeEventsLib } from '../js-bridge';
import { amplitudeEventsLib } from '../amplitude-events';
import { googleAnalyticsEventsLib } from '../google-analytics-events';
import { bloomreachEventsLib } from '../bloomreach-events';
import type { SelectFareFamilyParams } from './types';

export const selectFareFamily = (params: SelectFareFamilyParams) => {
  googleAnalyticsEventsLib.selectFareFamily(params.choice);
  amplitudeEventsLib.selectFareFamily(params);
  jsBridgeEventsLib.passengerPageOpened(params);
  bloomreachEventsLib.selectFareFamily(params);
};

export const continueFareFamily = (params: {
  isFareFamiliesFlexible: boolean;
  isError: boolean;
}) => {
  amplitudeEventsLib.continueFareFamily(params);
};

export const fareFamilyPageOpen = () => {
  googleAnalyticsEventsLib.fareFamilyPageOpen();
};
